import {
  GET_USER_VERIFICATION_SETUP_DATA, VERIFY_USER_PHONE_SETUP, GENERATE_OTP_SECRET_DATA_SETUP,
  SEND_PHONE_VERIFICATION_CODE_SETUP, VERIFY_USER_OTP_SETUP, DELETE_OTP_SECRET_DATA_SETUP, SAVE_USER_VERIFICATION_DATA,
} from '../../../../constants/system/actions';

const getUserVerificationSetupData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_USER_VERIFICATION_SETUP_DATA, payload, resolve, reject,
});

const verifyUserPhoneSetup: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: VERIFY_USER_PHONE_SETUP, payload, resolve, reject,
});

const generateOtpSecretDataSetup: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GENERATE_OTP_SECRET_DATA_SETUP, payload, resolve, reject,
});

const sendPhoneVerificationCodeSetup: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SEND_PHONE_VERIFICATION_CODE_SETUP, payload, resolve, reject,
});

const verifyUserOtpSetup: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: VERIFY_USER_OTP_SETUP, payload, resolve, reject,
});

const deleteOtpSecretDataSetup: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_OTP_SECRET_DATA_SETUP, payload, resolve, reject,
});

const saveUserVerificationData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_USER_VERIFICATION_DATA, payload, resolve, reject,
});

export {
  getUserVerificationSetupData,
  verifyUserPhoneSetup,
  generateOtpSecretDataSetup,
  sendPhoneVerificationCodeSetup,
  verifyUserOtpSetup,
  deleteOtpSecretDataSetup,
  saveUserVerificationData,
};
